module.exports = __webpack_public_path__ + "static/media/1000980.31872958.png";